import { DATA_REQUEST_ASYNC } from './constants'

export const fetchData = (mailboxId) => ({
  type: DATA_REQUEST_ASYNC.INITIATE,
  payload: { mailboxId },
})
export const fetchDataSuccess = (data) => ({
  type: DATA_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchDataError = (error) => ({
  type: DATA_REQUEST_ASYNC.ERROR,
  error,
})
export const fetchDataCancel = () => ({ type: DATA_REQUEST_ASYNC.CANCEL })

export default {
  // to props
  fetchData,
  fetchDataCancel,
}
